import createReactComponent from '../createReactComponent';
export default createReactComponent('wind', 'Wind', [["path",{"d":"M18.325 7c3.485 0 3.485 5 0 5H3m15.411 9c3.452 0 3.452-5 0-5H3m7.872-13c3.506 0 3.506 5 0 5H3","key":"svg-0"}]]);